import React from 'react';
import { ArticleCard as ArticleCardType } from '@/sanity/fetchArticles';
import ArticleCard from './ArticleCard';
import HIHLink from '@/components/base/Link';
import { URL_PATH_ARTICLE } from '@/shared/constants';
import styles from './ArticlesList.module.scss';

interface ArticlesListProps {
  articles: ArticleCardType[];
  isSubMenuOpen?: boolean;
  label: string;
  onArticleClick: () => void;
}

const ArticlesList: React.FC<ArticlesListProps> = ({
  isSubMenuOpen,
  articles,
  label,
  onArticleClick,
}) => {
  return (
    <ul aria-label={label} className={styles.list}>
      {articles.map((article, i) => (
        <li
          key={article._id}
          className={[styles.item, i > 2 ? styles.hiddenMobile : '']
            .filter(Boolean)
            .join(' ')}
        >
          <HIHLink
            onClick={onArticleClick}
            href={`/${URL_PATH_ARTICLE}/${article.slug.current}`}
            tabIndex={isSubMenuOpen ? 0 : -1}
          >
            <ArticleCard article={article} />
          </HIHLink>
        </li>
      ))}
    </ul>
  );
};

export default ArticlesList;
